import React from 'react';
import { useChartOfAccounts } from '@/api/queries';
import type { LocaleCode } from '@/api/models';

export type AccountLabel = { code: string; name: string };

/**
 * Account id → code + localized name, for rendering journal lines.
 *
 * Shared by the journal entry drawer and the year-end preview dialogs so both
 * resolve names the same way from the same chart.
 */
export const useAccountLabelMap = (
    locale: LocaleCode,
    enabled = true,
): Map<string, AccountLabel> => {
    const { data: accounts } = useChartOfAccounts({ locale, enabled });

    return React.useMemo(() => {
        const map = new Map<string, AccountLabel>();
        accounts?.forEach((account) =>
            map.set(account.id, {
                code: account.code,
                name: account.name,
            }),
        );
        return map;
    }, [accounts]);
};
